module.exports = __webpack_public_path__ + "d664201f/img/google.68f3823e.svg";